module.exports = __webpack_public_path__ + "components/outside-promo-page/static/surf-forecast__icon-a473533de30a11e64001f030b3fae388.svg";